/*
  Collection infinite scroll (director, 2026-10-23: "one scrolling page instead of multiple pages").
  The page links stay in the HTML (crawlers and no-JS visitors use them); with JS they are hidden and the
  next page's products are fetched (section only) and appended as the visitor nears the end of the grid.
  A range heading that continues the last range on screen is not repeated. Filters re-render the grid
  (facets.js replaces #ProductGridContainer), so new grids are picked up by a MutationObserver.
*/
(function () {
  if (window.veInfiniteScroll) return;
  window.veInfiniteScroll = true;

  let busy = false;
  const observer = new IntersectionObserver(
    (entries) => entries.forEach((e) => e.isIntersecting && loadNext(e.target)),
    { rootMargin: '0px 0px 900px 0px' }
  );

  function arm() {
    document.querySelectorAll('.ve-infinite:not([data-ve-armed])').forEach((el) => {
      el.setAttribute('data-ve-armed', '');
      if (!el.dataset.veNext) return;
      const nav = el.querySelector('.pagination-wrapper');
      if (nav) nav.style.display = 'none';
      observer.observe(el);
    });
  }

  function status(el, on) {
    const s = el.querySelector('.ve-infinite__status');
    if (s) s.hidden = !on;
  }

  async function loadNext(el) {
    if (busy || !el.dataset.veNext) return;
    busy = true;
    status(el, true);
    try {
      const url = new URL(el.dataset.veNext, window.location.origin);
      url.searchParams.set('section_id', el.dataset.section);
      const res = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const grid = document.getElementById('product-grid');
      const newGrid = doc.getElementById('product-grid');
      if (!grid || !newGrid) throw new Error('no grid');

      const items = Array.from(newGrid.children);
      const shown = grid.querySelectorAll('.ve-range-heading__title');
      const lastTitle = shown.length ? shown[shown.length - 1].textContent.trim() : null;
      if (items.length && items[0].classList.contains('ve-range-heading') && items[0].textContent.trim() === lastTitle) {
        items.shift();
      }
      items.forEach((item) => grid.appendChild(document.adoptNode(item)));
      if (typeof initializeScrollAnimationTrigger === 'function') {
        const fresh = items.filter((i) => i.classList.contains('scroll-trigger'));
        initializeScrollAnimationTrigger({ getElementsByClassName: () => fresh });
      }

      const next = doc.querySelector('.ve-infinite');
      el.dataset.veNext = next ? next.dataset.veNext || '' : '';
      observer.unobserve(el);
      if (el.dataset.veNext) observer.observe(el); // fires again at once if the end is still in reach
    } catch (err) {
      const nav = el.querySelector('.pagination-wrapper');
      if (nav) nav.style.display = '';
      el.dataset.veNext = '';
      observer.unobserve(el);
    } finally {
      status(el, false);
      busy = false;
    }
  }

  // Backup trigger: some browsers and hidden tabs never report the intersection; check the position on scroll.
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    setTimeout(() => {
      ticking = false;
      document.querySelectorAll('.ve-infinite[data-ve-armed]').forEach((el) => {
        if (el.dataset.veNext && el.getBoundingClientRect().top < window.innerHeight + 900) loadNext(el);
      });
    }, 200);
  }, { passive: true });

  function start() {
    arm();
    const container = document.getElementById('ProductGridContainer');
    if (container) new MutationObserver(arm).observe(container, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
